export default "__VITE_ASSET__ce2a96f1__"